import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import { matchPath, Navigate, Outlet } from "react-router-dom";

const disputeDetailBreadcrumb = breadcrumbSlot();

const HIDE_PADDING_ROUTES: string[] = [
  "/disputes/chargebacks",
  "/disputes/chargebacks/*",
  "/disputes/:disputeId",
];

function hidePadding(url: string): boolean {
  return HIDE_PADDING_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/finance${route}`, url),
  );
}

export const financeRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Finance" },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page hidePadding={hidePadding} /> };
    },
    children: [
      { index: true, element: <Navigate replace to="disputes" /> },
      {
        path: "disputes",
        handle: { breadcrumb: "Disputes" },
        async lazy() {
          const { DisputesEnabledGate } = await import(
            "../../../finance/disputes/disputes-enabled-gate"
          );
          return {
            element: (
              <DisputesEnabledGate>
                <Outlet />
              </DisputesEnabledGate>
            ),
          };
        },
        children: [
          { index: true, element: <Navigate replace to="dashboard" /> },
          {
            path: "dashboard",
            handle: { breadcrumb: "Dashboard" },
            async lazy() {
              const { DisputesDashboardPage } = await import(
                "../../../finance/disputes/dashboard/disputes-dashboard-page"
              );
              return { Component: DisputesDashboardPage };
            },
          },
          {
            path: "chargebacks",
            handle: { breadcrumb: "Chargeback disputes" },
            async lazy() {
              const { DisputesPage } = await import(
                "../../../finance/disputes/disputes-page"
              );
              return { Component: DisputesPage };
            },
          },
          {
            path: "settings",
            handle: { breadcrumb: "Settings" },
            async lazy() {
              const { DisputesSettingsPage } = await import(
                "../../../finance/disputes/settings/disputes-settings-page"
              );
              return { Component: DisputesSettingsPage };
            },
          },
          {
            path: ":disputeId",
            handle: { breadcrumb: disputeDetailBreadcrumb },
            async lazy() {
              const { DisputeDetailPage } = await import(
                "../../../finance/disputes/dispute-detail-page"
              );
              return {
                element: (
                  <DisputeDetailPage breadcrumb={disputeDetailBreadcrumb} />
                ),
              };
            },
          },
        ],
      },
    ],
  },
];
